var _class, _descriptor, _descriptor2, _LinkToForcComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { LinkTo } from '@ember/routing';
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { route, models } from 'core/helpers/transition-to-forc';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
let LinkToForcComponent = (_class = (_LinkToForcComponent = class LinkToForcComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
  }
  get route() {
    return route(this.args.sourceJeId, this.args.asModal, this.session);
  }
  get models() {
    return models(this.args.feature, this.args.component, this.args.patient, this.args.sourceJeId, this.session);
  }
  get query() {
    return Object.assign({}, this.args.query, {
      isReadOnly: this.args.isReadOnly,
      originJournalEventType: this.args.originJournalEventType,
      originJournalEventId: this.args.originJournalEventId
    });
  }
}, setComponentTemplate(precompileTemplate("\n    <LinkTo @route={{this.route}} @models={{this.models}} @query={{this.query}} class={{@class}} @replace={{@replace}} ...attributes data-test-link-to-forc=\"{{@feature}}/{{@component}}\">\n      {{yield}}\n    </LinkTo>\n  ", {
  strictMode: true,
  scope: () => ({
    LinkTo
  })
}), _LinkToForcComponent), _LinkToForcComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { LinkToForcComponent as default };